module.exports = __webpack_public_path__ + "img/img_series_115.12aadf90.png";